module.exports = __webpack_public_path__ + "img/invoice2.d922f821.svg";